import axios from '../../../axios';
import ILocationRecord from '../types/ILocationRecord';

const url = '/locationsapi/api/location/';

export const searchLocation = (query: { query: string }) => axios.post(url + 'search', query);
export const findLocation = (queries: { queries: string[] }) => axios.post(url + 'find', queries);
export const recordLocation = (payload: ILocationRecord) => axios.post(url + 'record', payload);
